module.exports = __webpack_public_path__ + "static/ptp-pres1-620988670f2d8a1549d34455f805dd06.png";